// angular
// .module("HeroPRO")
// .controller("SuccessController", successController);

import './success.scss';

/* @ngInject */
export default function successController(NotificationCenterFactory, $rootScope) {
    const vm = this;
    vm.isLastActiveNotification = null;

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.nextClicked = function () {
        NotificationCenterFactory.setNextNotificationAsActive();
        $rootScope.$broadcast('notificationCompleted');
    };

    vm.closeClicked = function () {
        $rootScope.$broadcast('closeNotificationModal');
    };
    /* -----  End of Public Functions  ------*/


    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function init() {
        const activeNotification = NotificationCenterFactory.getActiveNotification();
        NotificationCenterFactory.markNotificationComplete(activeNotification.ActionItemId);
        vm.isLastActiveNotification = NotificationCenterFactory.isLastActiveNotification();
    }
    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/notificationCenter/modal/templates/advancedRegistration/success/successController.js